import React, { useState } from "react";
import { Collapse, Button } from "antd-mobile";
import { EyeOutline, EyeInvisibleOutline } from "antd-mobile-icons";
import { useI18n } from "@/i18n/hooks";
import styles from "./index.module.scss";

interface ErrorDetailsProps {
  error: Error;
}

export default function ErrorDetails({ error }: ErrorDetailsProps) {
  const { t } = useI18n();
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className={styles.errorDetails}>
      <Button
        size="mini"
        color="default"
        onClick={toggleVisibility}
        className={styles.toggleButton}
      >
        {isVisible ? <EyeInvisibleOutline /> : <EyeOutline />}
        {isVisible ? t("error.hideDetails") : t("error.showDetails")}
      </Button>

      {isVisible && (
        <Collapse>
          <Collapse.Panel key="error" title={t("error.message")}>
            <pre className={styles.errorMessage}>{error.message}</pre>
          </Collapse.Panel>

          {error.stack && (
            <Collapse.Panel key="stack" title={t("error.stackTrace")}>
              <pre className={styles.stackTrace}>{error.stack}</pre>
            </Collapse.Panel>
          )}
        </Collapse>
      )}
    </div>
  );
}
